import { HelpScout } from "./../shared/helpers/helpscout";
import { autoinject } from "aurelia-dependency-injection";
import Marionette from "../shared/marionette-mustache";
import { AppEvents } from "../app-events";
import {Container} from "aurelia-dependency-injection";
import {DocumentHolderCollection} from "../desktop/collections/document-holders";
import {DocumentHolderModel} from "../desktop/models/document-holder";
import {MobileHelper} from "../shared/helpers/mobile-helper";
import {DesktopModel} from "../desktop/models/desktop";
import { AppUser } from "../authentication/app-user";
import { AuthService } from "../authentication/auth-service";
import { ContainerHelper } from "../shared/helpers/container-helper";

const template = require<string>("../navigation/navigation.html");
declare var Beacon;
require("../navigation/side-navigation.less");

const options = {
    template
};

const dom = {
    APPLICATION_REGION: "#application-region",
    MOBILE_DOCUMENT_LIST: "#mobile-document-list",
    MOBILE_DOCUMENT_LIST_ITEM: ".mobile-list-item-text",
    MOBILE_DOCUMENT_LIST_ITEM_CLOSER: ".mobile-document-list-item-closer",
    MOBILE_DOCUMENT_CONTENT: ".document-content",
    MOBILE_NUMBER_OPEN_DOCUMENTS: ".mobile-num-open-docs",
    MOBILE_EMPTY_STATE: ".mobile-empty-state",
    DOCUMENT_HEADER: ".document-header",
};

@autoinject
export class Navigation extends Marionette.ItemView<any> {

    private desktop: DesktopModel;
    private user: AppUser;

    constructor(private appEvents: Backbone.Events, private hs: HelpScout) {
        super(options);
        this.user = ContainerHelper.AuthService.AppUser;
        this.setupEvents();
    }

    public setDesktopModel(model: DesktopModel) {
        this.desktop = model;
        this.listenTo(this.desktop.DocumentHolders, "remove", this.mobileRefreshListContent);
        this.listenTo(this.desktop.DocumentHolders, "add", this.mobileUpdateOpenDocumentsCount);
    }

    public initialiseBrowseButton() {
        if (this.user.Sku === "pro") {
            this.$("#browse-button").removeClass("disabled").attr("aria-disabled", "false");
            this.$("#browse-button").find("a").attr("title", "Browse JustisOne for case law and legislation");
        } else {
            this.$("#browse-button").addClass("disabled").attr("aria-disabled", "true");
            this.$("#browse-button").find("a").attr("title", "Subscription required to Browse JustisOne for case law and legislation");
        }
    }

    public initialize() {
        // Definition files require initialize method;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {
            "click a": (e) => this.handleClick(e)
        };
        const mh: MobileHelper = Container.instance.get(MobileHelper);
        if (mh.IsMobileMode) {
            events[`click ${dom.MOBILE_DOCUMENT_LIST_ITEM}`] = this.mobileDocumentLinkClick;
            events[`click ${dom.MOBILE_DOCUMENT_CONTENT}`] = (e) => this.mobileHideDocumentList(false);
            events[`swiperight ${dom.MOBILE_DOCUMENT_LIST_ITEM}`] = this.mobileCloseDocument;
            events[`click ${dom.MOBILE_DOCUMENT_LIST_ITEM_CLOSER}`] = this.mobileCloseDocument;
        }
        return events;
    }

    public toggleSettings(): void {
        this.$(".settings").toggleClass("selected");
    }

    public hide(): void {
        this.$("#navigation").addClass("vanish");
    }

    public unhide(): void {
        this.$("#navigation").removeClass("vanish");
    }

    public select(view: string): JQuery {
        if ($("." + view).hasClass("selected")) { // do this to stop flickering when you re-click the settings button on mobile
            return;
        }

        const mh: MobileHelper = Container.instance.get(MobileHelper);
        if (mh.IsMobileMode) { this.mobileSelect(view); }
        // chuck popovers
        $(".paragraph-controls").popover("destroy");
        $(".popover").popover("hide");
        return this.deselectAll().filter("." + view).addClass("selected"); // remove selected from all <li>, then add it to the desired one
    }

    public deselectAll(): JQuery {
        return this.$("li").removeClass("selected");
    }

    public toggleMobileDocumentList(holders: DocumentHolderCollection) {

        if ($("#mobile-document-list").is(":visible")) {
            this.mobileHideDocumentList();
            return;
        }
        $("#mobile-document-list ul").html("");
        if (!holders || holders.length < 2) { // only one or zero docs open, don't need to see list
            return;
        }
        this.mobileRefreshListContent();
        $(".mobile-mask").show();
        $("#mobile-document-list").slideDown(500);
    }

    /** Hides the mobile document list, and also hides the "mask" used to grey out the screen.
     * @param quick - whether we want it to slide down or disappear instantly
     */
    public mobileHideDocumentList(quick = false) {
        $(".mobile-mask").hide(); // bit that greys out the screen should go
        $(dom.DOCUMENT_HEADER).removeClass("mobile-nav-up"); // When we open a doc we don't want the header to be hidden, we wanna show the title
        if (quick) {
            $("#mobile-document-list").hide();
            return;
        }
        $("#mobile-document-list").slideUp(500);
    }

    private openHelpscoutBeacon(): void {
        Beacon("toggle");
    }

    private handleClick(e: JQueryEventObject) {
        e.preventDefault();

        if ($(e.currentTarget).parent().hasClass("disabled")) {
            e.stopPropagation();
            return;
        }
        const command = $(e.currentTarget).attr("data-command");
        if (typeof (command) !== "undefined") {
            if (command === "package") {
                const packageName = $(e.currentTarget).attr("data-package");
                this.appEvents.trigger(AppEvents.Package, packageName);
                return;
            }
            if (command === "helpdesk") {
                this.openHelpscoutBeacon();
                this.appEvents.trigger(AppEvents.AppInsightsDesktopHelpButton, {Button: "Clicked"});
            }
            if (command === "AdminSettings") {
                this.appEvents.trigger(AppEvents.AppInsightsDesktopAdminButton, {Button: "Clicked", Link: AdminLink});
                window.open(AdminLink);
            }
            this.appEvents.trigger(command);
            return;
        }
        const url = $(e.currentTarget).attr("href");
        if (url) { // If this is an actual url then go to it.

            if (url === Backbone.history.getFragment()) { // If you're already on this url
            this.select(url); // This is needed for mobile where settings can be open but you'll still be on a search/desktop url
            }
            if (url.substr(0, 4) === "http") {
                return true;
            }
            Backbone.history.navigate(url, { trigger: true });
        }
        return false;
    }

    private setupEvents(): void {
        this.appEvents.on(AppEvents.SearchRequest, () => {
            this.select("search");
        });
        this.appEvents.on(AppEvents.Desktop, () => {
            this.select("desktop");
        });
        this.appEvents.on(AppEvents.UserHistory, () => {
            this.select("history");
        });
        this.appEvents.on(AppEvents.DesktopDocumentAdded, () => {
            this.$(".desktop").removeClass("disabled").attr("aria-disabled", false.toString());
        });
        this.appEvents.on(AppEvents.DesktopDocumentRemoved, (args) => {
            this.$(".desktop").toggleClass("disabled", args.documentCount === 0).attr("aria-disabled", (args.documentCount === 0).toString());
        });
    }

    /** Do not call this method. Is just extra functionality for the "select()" method that supports mobile.
     * This should never be called except once inside the select() method
     */
    private mobileSelect(view: string) {
        // add class to application region - needed for mobile CSS to take effect
        $(dom.APPLICATION_REGION).removeClass();
        $(dom.APPLICATION_REGION).addClass(view);
    }

    /** For when a document is removed, be it closed from the menu, or this could happen via the document "x" button even if the menu is closed
     */
    private mobileRefreshListContent() {
        this.mobileUpdateOpenDocumentsCount(); // update navbar
        $("#mobile-document-list ul").html(this.mobileBuildDocumentList()); // rebuild the list (not changing if its shown or not)
        if (this.desktop.DocumentHolders.length === 0 ) {
            this.mobileHideDocumentList(); // if we have 0 docs close the list
        }
    }

    private mobileShowOrHideDesktopEmptyState() {
        if (this.desktop.DocumentHolders.length) {
            $(dom.MOBILE_EMPTY_STATE).hide();
        } else {
            $(dom.MOBILE_EMPTY_STATE).show();
        }
    }

    private mobileBuildDocumentList() {

        let list = "<h5>Open Documents</h5>";
        this.desktop.DocumentHolders.forEach((dh) => {
            const closer = `<div data-id="${dh.TargetModel.Id}" class="mobile-document-list-item-closer"><i class="fa fa-remove"></i></div>`;
            const content = `<li class="mobile-document-list-item"><span data-url=${dh.TargetModel.Url} class="mobile-list-item-text">${dh.TargetModel.Title}</span> ${closer}</li> `;
            list += content;
        });
        return list;
    }

    private mobileCloseDocument(e: JQueryEventObject) {
        const idToClose = $(e.target).parent().data("id");

        const  holder = this.desktop.DocumentHolders.findWhere((d: DocumentHolderModel) => d.getDocumentById(idToClose));
        const numDocs = this.desktop.DocumentHolders.length;
        if (holder) {
            this.appEvents.trigger(AppEvents.DocumentHolderClosed, holder);
            if (numDocs < 2) { // we check length before (to prevent race conditions so if its length 1 or 0 before, it'll be 0 after so hide list)
                this.mobileHideDocumentList();
            }
        }

        return false;
    }

    private mobileUpdateOpenDocumentsCount() {
        this.mobileShowOrHideDesktopEmptyState();
        $(dom.MOBILE_NUMBER_OPEN_DOCUMENTS).text(this.desktop.DocumentHolders.length);
    }

    private mobileDocumentLinkClick(e: JQueryEventObject) {
        const targetDocUrl = $(e.currentTarget).data("url");
        _.delay(() => {
            Backbone.history.navigate(targetDocUrl, true);
            this.mobileHideDocumentList();
        }, 150);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/navigation/navigation.ts